<template lang="pug">
  div
    error-modal(v-if="showError", :lang="lang", @closeError="closeError", :errorSel="errorSel", :matrix="matrixSel")
    .container-fluid
      .row
        .col-sm-4
          nav(aria-label="Page navigation")
            ul.pagination
              li(:class="{ active: perPage === 10}")
                a(href="#", @click.prevent="changePerPage(10)") 10
              li(:class="{ active: perPage === 20}")
                a(href="#", @click.prevent="changePerPage(20)") 20
              li(:class="{ active: perPage === 50}")
                a(href="#", @click.prevent="changePerPage(50)") 50
              li(:class="{ active: perPage === 100}")
                a(href="#", @click.prevent="changePerPage(100)") 100
        .col-sm-4.text-center
          nav(aria-label="Page navigation")
            ul.pagination
              li
                router-link(:to="{name: 'devices', params: {type: originType}}" @click.native="setOpenDetailId()") {{$options.filters.translate('return to kiosk', lang)}}
                  strong &nbsp; {{ device.name }}
                router-link(:to="{name: 'devices', params: {type: originType}}") {{$options.filters.translate('Return to list', lang)}}
        .col-sm-4
          nav(aria-label="Page navigation")
            ul.pagination.pull-right
              li(:class="previousClass")
                a(href="#", @click.prevent="getPrevious()", aria-label="Previous")
                  span(aria-hidden="true") &laquo;
              li
                a {{page}}
              li(:class="nextClass")
                a(href="#", @click.prevent="getNext()", aria-label="Next")
                  span(aria-hidden="true") &raquo;
      .row
        table.table.table-hover
          thead
            th {{$options.filters.translate('Date', lang)}}
            th {{$options.filters.translate('Code', lang)}}
            th {{$options.filters.translate('Place', lang)}}
            th {{$options.filters.translate('Object', lang)}}
            th {{$options.filters.translate('Error', lang)}}
            th {{$options.filters.translate('Level', lang)}}
            th {{$options.filters.translate('Email', lang)}}
          tbody
            tr(v-for="error in errors", :key="error.id", :class="error.matrix.level | matrixLevelClass", @dblclick="showError = true; errorSel = error; matrixSel = error.matrix;")
              td {{error.createdAt | formatDateTime}}
              td {{error.matrix.code}}
              td {{error.matrix.area}}
              td {{error.matrix.object}}
              td {{error.matrix.error}}
              td {{error.matrix.level}}
              td
                i.fa(:class="error.sentR | sentIcon", aria-hidden="true")
      .row
        .col-sm-4
          nav(aria-label="Page navigation")
            ul.pagination
              li(:class="{ active: perPage === 10}")
                a(href="#", @click.prevent="changePerPage(10)") 10
              li(:class="{ active: perPage === 20}")
                a(href="#", @click.prevent="changePerPage(20)") 20
              li(:class="{ active: perPage === 50}")
                a(href="#", @click.prevent="changePerPage(50)") 50
              li(:class="{ active: perPage === 100}")
                a(href="#", @click.prevent="changePerPage(100)") 100
        .col-sm-4.text-center
          nav(aria-label="Page navigation")
            ul.pagination
              li
                router-link(:to="{name: 'devices', params: {type: originType}}" @click.native="setOpenDetailId()") {{$options.filters.translate('return to kiosk', lang)}}
                  strong &nbsp; {{ device.name }}
                router-link(:to="{name: 'devices', params: {type: originType}}") {{$options.filters.translate('Return to list', lang)}}
        .col-sm-4
          nav(aria-label="Page navigation")
            ul.pagination.pull-right
              li(:class="previousClass")
                a(href="#", @click.prevent="getPrevious()", aria-label="Previous")
                  span(aria-hidden="true") &laquo;
              li
                a {{page}}
              li(:class="nextClass")
                a(href="#", @click.prevent="getNext()", aria-label="Next")
                  span(aria-hidden="true") &raquo;
</template>
<script>
import errorModal from '@/components/errors/Error'

export default {
  name: 'errorsList',
  props: ['lang', 'device', 'originType'],
  data () {
    return {
      showError: false,
      page: 1,
      perPage: 10,
      errors: [],
      matrixSel: ''
    }
  },
  components: {
    'error-modal': errorModal
  },
  watch: {
  },
  computed: {
    previousClass () {
      return (this.page === 1) ? 'disabled' : ''
    },
    nextClass () {
      return (this.errors.length !== this.perPage) ? 'disabled' : ''
    }
  },
  methods: {
    setOpenDetailId () {
      this.$store.commit('SET_OPENDETAILID', this.device.id)
    },
    changePerPage (val) {
      this.page = 1
      this.perPage = val
      this.getErrors()
    },
    getPrevious () {
      if (this.page !== 1) {
        this.page -= 1
        this.getErrors()
      }
    },
    getNext () {
      if (this.errors.length === this.perPage) {
        this.page += 1
        this.getErrors()
      }
    },
    getErrors () {
      this.$http.get('networkerrormatrixerror',
        {
          params:
          {
            where: {device: this.device.id},
            limit: this.perPage,
            skip: ((this.page - 1) * this.perPage),
            sort: 'createdAt DESC'
          }
        })
        .then(response => {
          return response.json()
        })
        .then(data => {
          const resultArray = []
          for (let key in data) {
            resultArray.push(data[key])
          }
          this.errors = resultArray
        })
    },
    closeError () {
      this.showError = false
    }
  },
  created () {
    this.getErrors()
  }
}
</script>
<style lang="sass" scoped>
@import "~sass/_variables.scss"

.sm-width
  width: 50px
  white-space: nowrap

table
  overflow-y: scroll
  max-height: 370px

  td
    cursor: pointer

  .level1
    background-color: $brand-danger

  .level2
    background-color: $brand-warning

  .level3
    background-color: $brand-info

  .level-
    background-color: none
</style>



// WEBPACK FOOTER //
// src/components/errors/ErrorsList.vue